

import React from 'react'
import image from '../../Assets/images/error-404_108061-66.jpg'
export default function Notfound() {
  return <>
  
       <div className='container pt-5 align-content-center justify-content-center'>

        <div className="col-md-6  pt-2 align-content-center justify-content-center mx-auto">
        <img src={image} alt="notfound" className='w-100' />
        </div>

       </div>
  
  </>
}
